<template>
    <button :name="'go-to-' + targetStep" @click="switchStep()">
        <slot>
            {{ targetStep }}
        </slot>
    </button>
</template>

<script>
/**
 * This switch contains all the necessary methods to be able to switch between all the different order process steps.
 */
import {orderProcess} from "../../store/constants/order-process";
import order from "../../store/modules/order";

export default {
    name: "OrderProcessStepSwitch",
    data() {
        return {
            orderProcess
        }
    },
    props: {
        targetStep: {
            type: String,
            required: false,
            default: orderProcess.STEPS.NO_ORDER_ONGOING
        }
    },
    methods: {
        switchStep() {
            switch (this.targetStep) {
                case orderProcess.STEPS.NO_ORDER_ONGOING:
                    this.returnToStart();
                    break;
                case orderProcess.STEPS.FILE_UPLOAD:
                    break;
                case orderProcess.STEPS.CONFIGURE_MODEL:
                    break;
                case orderProcess.STEPS.VIEW_CART:
                    break;
                case orderProcess.STEPS.REVIEW_ORDER:
                default:
                    this.returnToStart();
            }
        },
        returnToStart() {

        }
    }
}
</script>
<style>

</style>